import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/modules/App";
import "@/styles/app.css";

const el = document.getElementById("root");
if (!el) {
  throw new Error("root_missing");
}

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>
);
